<template>
    <v-row no-gutters style="flex-grow:0">
        <v-col cols="auto">
            <v-btn icon text :to="hasPrev ? `/auction-works/${work.meta._prev}` : null" :disabled="!hasPrev"> <v-icon>mdi-chevron-left</v-icon> </v-btn>
        </v-col>
        <template v-if="is(PROGRAM)">
            <v-col cols="auto">
                <v-btn icon text :to="`/auction-halls/${work.meta.hall}/groups/all`" :disabled="isEnded"> <v-icon>mdi-menu</v-icon> </v-btn>
            </v-col>
        </template>
        <template v-if="is(PRIVATE)">
            <v-col cols="auto">
                <v-btn icon text :to="`/private-sales/LIST`" :disabled="isEnded"> <v-icon>mdi-menu</v-icon> </v-btn>
            </v-col>
        </template>
        <v-col cols="auto">
            <v-btn icon text :to="hasNext ? `/auction-works/${work.meta._next}` : null" :disabled="!hasNext"> <v-icon>mdi-chevron-right</v-icon> </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { WORK_AUCTION_MODES } from "@/assets/variables";
const { NULL, PRIVATE, PROGRAM } = WORK_AUCTION_MODES;

export default {
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        NULL,
        PRIVATE,
        PROGRAM,
    }),
    computed: {
        isEnded() {
            if (this.work.mode_auction == PRIVATE.value) return this.work.isSoldOut;
            if (this.work.mode_auction == PROGRAM.value) return this.work.isProgramEnded;
            return true;
        },
        hasPrev() {
            return !!this.work.meta?._prev;
        },
        hasNext() {
            return !!this.work.meta?._next;
        },
    },
    methods: {
        is({ value } = {}) {
            return this.work.mode_auction == value;
        },
    },
};
</script>

<style></style>
